import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

const getCompanyDomains = createSelector(getCompany, ({ domains }) => domains);

export const getCompanyDomainsValues = createSelector(
  getCompanyDomains,
  companyDomains => Object.values(companyDomains)[0],
);

export const getFilteredCompanyDomains = createSelector(
  getDebouncedSearchValue,
  getCompanyDomainsValues,
  searchItems(domain => [domain.domainName]),
);
